import { Component } from '@angular/core';
import { FieldType } from '@ngx-formly/core';

@Component({
    selector: 'ups-textarea',
    template: ` <ngl-textarea [label]="to.label || ''">
    <textarea
      ngl
      [formControl]="$any(formControl)"
      [required]="to.required || false"
      [placeholder]="to.placeholder"
      [autocomplete]="to.attributes?.['autocomplete'] || 'nope'"
      class="custom-class"
    >
    </textarea>
  </ngl-textarea>`,
    styleUrls: ['./textarea.type.component.scss'],
    standalone: false
})
export class TextareaTypeComponent extends FieldType {}
